__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-29-1785321508-stable-dev/";